import type { ReactNode } from 'react'

export type AlertTone = 'info' | 'success' | 'warning' | 'error'

interface AlertProps {
  readonly tone?: AlertTone
  readonly title?: string
  readonly children: ReactNode
  readonly className?: string
}

const TONE: Record<AlertTone, { bg: string; text: string; icon: string }> = {
  info: { bg: 'bg-forest/10 border-forest/20', text: 'text-forest', icon: 'ℹ' },
  success: { bg: 'bg-success/15 border-success/30', text: 'text-success', icon: '✓' },
  warning: { bg: 'bg-bamboo/25 border-bamboo/40', text: 'text-charcoal', icon: '⚠' },
  error: { bg: 'bg-terra/15 border-terra/30', text: 'text-terra', icon: '✕' }
}

export function Alert({ tone = 'info', title, children, className = '' }: AlertProps): JSX.Element {
  const t = TONE[tone]
  return (
    <div
      role="alert"
      className={`flex gap-3 p-4 rounded-md border ${t.bg} ${t.text} ${className}`.trim()}
    >
      <span aria-hidden className="font-medium">
        {t.icon}
      </span>
      <div className="font-body text-body-sm flex-1">
        {title !== undefined ? <p className="font-medium mb-1">{title}</p> : null}
        <div className="opacity-90">{children}</div>
      </div>
    </div>
  )
}
